import config from '../config.json';
export default (function () {
  if (config.env.indexOf('dev') !== -1 || config.env.indexOf('docker') !== -1) {
    for (var _len = arguments.length, output = new Array(_len), _key = 0; _key < _len; _key++) {
      output[_key] = arguments[_key];
    }
    output.forEach(item => {
      /* eslint-disable no-console */
      console.log(item);
      /* eslint-enable no-console */
    });
  }
});